import script from "./ContributorOverviewTrend.vue?vue&type=script&setup=true&lang=js"
export * from "./ContributorOverviewTrend.vue?vue&type=script&setup=true&lang=js"

import "./ContributorOverviewTrend.vue?vue&type=style&index=0&id=73abdf15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73abdf15"]])

export default __exports__